<div [formGroup]="form">
    <div formArrayName="plans">
        @for (plan of plans.controls; track plan; let i = $index) {
        <div [formGroupName]="i" class="card mb-4 border-2">
            <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h5 class="mb-0 fw-bold text-dark">Plan {{ i + 1 }}</h5>
                <button (click)="removePlan(i)"
                    class="btn bg-white text-colonial border border-2 border-colonial btn-sm d-flex align-items-center gap-1"
                    type="button">
                    <span class="material-symbols-outlined fs-6">delete</span>
                    Eliminar Plan
                </button>
            </div>
            <div class="card-body">
                <div class="row g-3 mb-4">
                    <div class="col-md-6">
                        <label class="form-label fw-bold">Nombre del Plan</label>
                        <input class="form-control" formControlName="name" placeholder="Ej: Plan I" type="text">
                    </div>
                    <div class="col-md-6">
                        <label class="form-label fw-bold">Pago por Diagnóstico</label>
                        <div class="input-group">
                            <span class="input-group-text bg-light fw-bold">$</span>
                            <input class="form-control" formControlName="diagnosisPayout" mask="separator"
                                placeholder="0.00" thousandSeparator="," type="text">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label fw-bold d-flex align-items-center gap-1">
                            Pago por Supervivencia
                            <span class="material-symbols-outlined fs-6 text-muted cursor-pointer"
                                ngbTooltip="Este es el monto total que se le pagará al cliente por períodos después de haber sido diagnosticado con la enfermedad">
                                info
                            </span>
                        </label>
                        <div class="input-group">
                            <span class="input-group-text bg-light fw-bold">$</span>
                            <input class="form-control" formControlName="survivalPayout" mask="separator"
                                placeholder="0.00" thousandSeparator="," type="text">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label fw-bold">Meses pago Supervivencia</label>
                        <input class="form-control" formControlName="survivalPeriodMonths" mask="separator"
                            placeholder="0" thousandSeparator="," type="text">
                        <small class="text-muted d-block mt-1">
                            Pago mensual: {{ calculateMonthlyPayout(i) | currency:'DOP':'symbol-narrow':'1.2-2' }}
                        </small>
                    </div>
                </div>

                <!-- Coberturas del Plan -->
                <div class="border-top pt-3 mb-4">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="mb-0 fw-bold underline-red">Coberturas del Plan</h6>
                        <button (click)="openCoverageModal(i)"
                            class="btn btn-outline-colonial btn-sm px-3 d-flex align-items-center gap-1" type="button">
                            <span class="material-symbols-outlined fs-6">add_circle</span>
                            Nueva Cobertura
                        </button>
                    </div>
                    <ng-select [items]="availableCoverages" [loading]="loading" bindLabel="name" bindValue="id"
                        placeholder="Seleccionar coberturas..." [multiple]="true" [closeOnSelect]="false"
                        [ngModel]="getCoverageIds(i)" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onCoverageIdsChange(i, $event)" class="w-100">
                    </ng-select>
                </div>

                <div class="border-top pt-3">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h6 class="mb-0 fw-bold underline-red">Tarifas por Edad</h6>
                        <button (click)="addPremium(i)" class="btn btn-success btn-sm px-3" type="button">
                            <i class="bi bi-plus-circle me-1"></i>
                            Agregar Tarifa
                        </button>
                    </div>

                    <div class="table-responsive" formArrayName="premiums">
                        <table class="table table-hover table-bordered align-middle">
                            <thead class="bg-colonial text-white">
                                <tr>
                                    <th class="py-2">Desde Edad</th>
                                    <th class="py-2">Hasta Edad</th>
                                    <th class="py-2">Prima (DOP)</th>
                                    <th style="width: 50px;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (premium of getPremiums(i).controls; track premium; let j = $index) {
                                <tr [formGroupName]="j">
                                    <td class="p-0">
                                        <input class="form-control form-control-sm border-0 shadow-none px-3 py-2"
                                            formControlName="minAge" mask="0*" type="text">
                                    </td>
                                    <td class="p-0">
                                        <input class="form-control form-control-sm border-0 shadow-none px-3 py-2"
                                            formControlName="maxAge" mask="0*" type="text">
                                    </td>
                                    <td class="p-0">
                                        <input class="form-control form-control-sm border-0 shadow-none px-3 py-2"
                                            formControlName="amount" mask="separator" thousandSeparator="," type="text">
                                    </td>
                                    <td class="text-center p-0">
                                        <button (click)="removePremium(i, j)" class="btn btn-link text-danger p-2"
                                            type="button">
                                            <span class="material-symbols-outlined">delete</span>
                                        </button>
                                    </td>
                                </tr>
                                }
                                @if (getPremiums(i).length === 0) {
                                <tr>
                                    <td class="text-center text-muted py-4 small" colspan="4">
                                        <i class="bi bi-info-circle me-1"></i> No hay tarifas configuradas para este
                                        plan.
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>

    <button (click)="addPlan()" class="btn w-100 py-3 shadow-sm bg-colonial text-white" type="button">
        <i class="bi bi-plus-square-fill me-2"></i>
        Agregar Nuevo Plan de Enfermedades Graves
    </button>
</div>

<app-coverage-modal [isVisible]="showCoverageModal" (closed)="onCoverageModalClosed($event)"></app-coverage-modal>